import { VStack } from '@chakra-ui/react';
import HeaderSectionMobilePage from '../../../../../components/Mobile/headerSection';
import { IDataToRegistration } from '../../../../../services/hooks/CandidateArea/useGetDataToRegistration';
import FormVacancyMobilePage from './vacancy';
import FormCultureHouseMobilePage from './cultureHouse';

interface IOwnProps {
  selectiveProcess?: IDataToRegistration;
}

const RegistrationVacancyMobilePage: React.FC<IOwnProps> = (props) => {
  const { selectiveProcess } = props;

  return (
    <VStack w="full" gap={3} mt={1}>
      <HeaderSectionMobilePage>
        {selectiveProcess?.is_cultural_house ? 'TURMA' : 'VAGA / CARGO DESEJADA'}
      </HeaderSectionMobilePage>
      {(selectiveProcess?.is_cultural_house && <FormCultureHouseMobilePage selectiveProcess={selectiveProcess} />) || (
        <FormVacancyMobilePage selectiveProcess={selectiveProcess} />
      )}
    </VStack>
  );
};

export default RegistrationVacancyMobilePage;
